const DETERMINATION_REASON = {
  REFERIDO_DEVUELTA_SAEE: 41,
};

export default DETERMINATION_REASON;
